import { defineMessages } from "react-intl";

export const wpxTableMessages = defineMessages({
  columns: {
    id: "wpxTable.toolbar.columns",
    defaultMessage: "Columns",
  },
  exitFullScreen: {
    id: "wpxTable.toolbar.exitFullScreen",
    defaultMessage: "Exit Full Screen",
  },
  enterFullScreen: {
    id: "wpxTable.toolbar.enterFullScreen",
    defaultMessage: "Enter Full Screen",
  },
  escShortcut: {
    id: "wpxTable.toolbar.escShortcut",
    defaultMessage: "Esc",
  },
  resetColumnOrder: {
    id: "wpxTable.toolbar.resetColumnOrder",
    defaultMessage: "Reset Column Order",
  },
  sortAscending: {
    id: "wpxTable.header.sortAscending",
    defaultMessage: "Sort ascending",
  },
  sortedAscending: {
    id: "wpxTable.header.sortedAscending",
    defaultMessage: "Sorted ascending",
  },
  sortedDescending: {
    id: "wpxTable.header.sortedDescending",
    defaultMessage: "Sorted descending",
  },
  rowsSelected: {
    id: "wpxTable.footer.rowsSelected",
    defaultMessage: "{selected} of {total} row(s) selected.",
  },
  showingTotalResults: {
    id: "wpxTable.footer.showingTotalResults",
    defaultMessage:
      "Showing <strong>{visible}</strong> / <strong>{count}</strong> total results",
  },
  selected: {
    id: "wpxTable.floatingMenu.selected",
    defaultMessage: "{count} selected",
  },
  saveFile: {
    id: "wpxTable.export.saveFile",
    defaultMessage: "Save File",
  },
  export: {
    id: "wpxTable.export.export",
    defaultMessage: "Export",
  },
  fileName: {
    id: "wpxTable.export.fileName",
    defaultMessage: "File Name",
  },
  enterFileName: {
    id: "wpxTable.export.enterFileName",
    defaultMessage: "Enter File Name",
  },
  fileType: {
    id: "wpxTable.export.fileType",
    defaultMessage: "File Type",
  },
  selectFileType: {
    id: "wpxTable.export.selectFileType",
    defaultMessage: "Select File Type",
  },
  cancel: {
    id: "wpxTable.export.cancel",
    defaultMessage: "Cancel",
  },
  invalidFileName: {
    id: "wpxTable.export.invalidFileName",
    defaultMessage: "Invalid File Name",
  },
  fileNameRequired: {
    id: "wpxTable.export.fileNameRequired",
    defaultMessage: "File name is required",
  },
  fileNameMaxLength: {
    id: "wpxTable.export.fileNameMaxLength",
    defaultMessage: "File name cannot exceed 50 characters",
  },
  fileNameInvalidChars: {
    id: "wpxTable.export.fileNameInvalidChars",
    defaultMessage:
      "File name can only contain alphanumeric characters, underscores, hyphens, and dots",
  },
  fileNameCannotStartWithDot: {
    id: "wpxTable.export.fileNameCannotStartWithDot",
    defaultMessage: "File name cannot start with a dot",
  },
  fileNameCannotEndWithDot: {
    id: "wpxTable.export.fileNameCannotEndWithDot",
    defaultMessage: "File name cannot end with a dot",
  },
  selectOption: {
    id: "wpxTable.editor.selectOption",
    defaultMessage: "Select option",
  },
  searchPlaceholder: {
    id: "wpxTable.editor.searchPlaceholder",
    defaultMessage: "Search...",
  },
  noData: {
    id: "wpxTable.empty.noData",
    defaultMessage: "No Data",
  },
  noRecordsFound: {
    id: "wpxTable.empty.noRecordsFound",
    defaultMessage: "No records found",
  },
  datePlaceholder: {
    id: "wpxTable.editor.datePlaceholder",
    defaultMessage: "D/M/YYYY",
  },
  columnOrderCleanupFailed: {
    id: "wpxTable.columnOrder.cleanupFailed",
    defaultMessage: "Failed to clean up column order from localStorage.",
  },
  columnOrderResetFailed: {
    id: "wpxTable.columnOrder.resetFailed",
    defaultMessage: "Failed to reset column order. Please try again.",
  },
});
